import styles from './VisionLink.module.scss';
import { VisionLinkProp } from './types';
import cx from 'classnames';

export const VisionLink = ({ classname, children }: Readonly<VisionLinkProp>) => {
  return (
    <div className={cx(`p-3 ${styles['c-vision-link-wrapper']} ${classname}`)}>
      {children}
    </div>
  );
};
